import React, { useState, useEffect, useContext, useRef, createContext } from "react";
import $ from "jquery"
import OwlCarousel from "react-owl-carousel3";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Main from "../components/layout/Main";
import logoVerticaleTheme from "../../src/assets/images/logoVerticaleTheme.png";
import Form from 'react-bootstrap/Form';
import { Button, Typography, Spin } from "antd";
import fileUploadIcon from "../../src/assets/images/fileUploadIcon.png";
// import addPlayerIcon from "../assets/images/addPlayerIcon.png";

import backArrow from "../assets/images/backArrow.png";
import Modal from 'react-bootstrap/Modal';
import leftBtnArrow from "../assets/images/leftBtnArrow.png";
import rightBtnArrow from "../assets/images/rightBtnArrow.png";
import plusIconTheme2 from "../assets/images/plusIconTheme2.png";
import clockIconFill from "../assets/images/clockIconFill.png";
import exitIcon from "../assets/images/exitIcon.png";
import useRequest from "../../src/hooks/useRequest"
import searchIcon from "../assets/images/searchIcon.png";
import DraggableNumberPicker from './DraggableNumberPickerx.js'; // Import at the top of your file

import { useNavigate, useLocation, useParams, Link } from "react-router-dom";
import { ShowToast, Severty } from "../helper/toast";

import ImprovedTimer from "./ImprovedTimer";
import { HoleContext } from "./HoleContext";
import LiveCam from "../components/LC/LiveCam.js";

function ScoreKeeping() {
  const location = useLocation();

  const { gameId } = useParams();
  let id = gameId

  // console.log("gameId in scoreKeeping page", gameId)
  const [loading, setLoading] = useState(false);
  const addPlayerModalOpen = () => addPlayerModal(true);

  const [currentHole, setCurrentHole] = useState(1);
  const [friendList, setFriendList] = useState([])
  const { request } = useRequest();
  const navigate = useNavigate();
  const [newPostShow, newPostModal] = useState(false);
  const [show, scoreCardStepModal] = useState(false);
  const [Sdetail, setSdetail] = useState({})
  const scoreCardStepModalClose = () => scoreCardStepModal(false);
  const scoreCardStepModalOpen = () => scoreCardStepModal(true);
  const [scoreCard, setScoreCard] = useState()
  const [profile, setProfile] = useState({})
  const [gdetail, setGameDetail] = useState({})
  const closeAddScoreModal = () => { setAddScoreShow(false); };
  const newPostModalClose = () => newPostModal(false);
  const [addPlayerShow, addPlayerModal] = useState(false);
  const addPlayerModalClose = () => addPlayerModal(false);
  const [selectedFriends, setSelectedFriends] = useState([]);
  const [courseList, setCourseList] = useState([])

  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const [addScore, setAddScore] = useState([])
  const [holeMax, setholeMax] = useState('')
  const [isEndGame, setIsEndGame] = useState(false);
  const [GameCreator, setGameCreator] = useState(null);
  const [showLiveCamera, setShowLiveCamera] = useState(false);

  const [addScoreShow, setAddScoreShow] = useState(false);
  // Track total round duration from server
  const [serverRoundDuration, setServerRoundDuration] = useState(0);
  // const {  setActiveHole } = useContext(HoleContext);
  const [selectedValue, setSelectedValue] = useState('');
  const [userInitPar, setUserInitPar] = useState(-1);
  const [formEndData, setFormEndData] = useState({
    media: "",
    isPutts: false,
  });


  const openGameEndPopup = () => {
    setIsEndGame(true);
  }




  const HandleSubmitEnd = (event) => {
    event.preventDefault();
    // console.log("gdata", gdetail);

    // Create post for the game creator
    const creatorGameDetail = gdetail.gameDetailsId.find(detail => detail.user._id === GameCreator);

    var creatorPost = {
      title: "",
      description: "",
      course: gdetail.courseData.name,
      holes: gdetail.holes,
      media: formEndData.media,
      isPutts: formEndData.isPutts,
      putts: formEndData.isPutts ? creatorGameDetail.putts : 0,
      isPrivate: gdetail.posts_privacy,
      isScore: true,
      score: creatorGameDetail.totalScore,
      gameId: gameId,
      userID: GameCreator,
    };

    // console.log("Creator post details:", creatorPost);

    // Remove the putts field if isPutts is false
    if (!creatorPost.isPutts) {
      delete creatorPost.putts;
    }

    // Create an array to hold posts for all players
    const allPlayerPosts = [];

    // Add creator's post
    allPlayerPosts.push(creatorPost);

    // Loop through other players and create posts for them
    gdetail.gameDetailsId.forEach(playerDetail => {
      // Skip the creator as we've already added their post
      if (playerDetail.user._id !== GameCreator) {
        const playerPost = {
          title: "",
          description: "",
          course: gdetail.courseData.name,
          holes: gdetail.holes,
          isScore: true,
          score: playerDetail.totalScore,
          gameId: gameId,
          userID: playerDetail.user._id,
        };

        allPlayerPosts.push(playerPost);
      }
    });

    // console.log('All player posts:', allPlayerPosts);

    // Track successful and failed posts
    let successCount = 0;
    let failCount = 0;
    const totalPosts = allPlayerPosts.length;

    // Function to check if all requests are completed
    const checkCompletion = () => {
      if (successCount + failCount === totalPosts) {
        if (failCount === 0) {
          ShowToast("All posts added successfully", Severty.SUCCESS);
        } else {
          ShowToast(`${successCount} posts added, ${failCount} failed`, Severty.WARNING);
        }
        navigate('/home');
        closeEndGame();
      }
    };

    // Submit each post sequentially
    allPlayerPosts.forEach((post, index) => {
      request({
        url: "/app/post/add-post",
        method: "POST",
        data: post,
        onSuccess: (data) => {
          // console.log(`Post ${index + 1}/${totalPosts} added successfully`);
          successCount++;
          checkCompletion();
        },
        onError: (error) => {
          // console.log(`Failed to add post ${index + 1}/${totalPosts}:`, error);
          failCount++;
          checkCompletion();
        },
      });
    });
  }
  const closeEndGame = () => {
    setIsEndGame(false);
  };

  const [selectedNumber, setSelectedNumber] = useState(4);
  const carouselRef = useRef(null);
  const numbers = Array.from({ length: 19 }, (_, i) => i + 1);
  const [carouselWidth, setCarouselWidth] = useState(400); // Width to fit 5 items

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    course: "",
    holes: "",
    media: "",
    isScore: false,
    score: "",
  });



  const newPostModalOpen = () => {
    // Pre-populate form data with game details
    setFormData({
      title: "",
      description: "",
      course: gdetail?.course || "",  // Auto-select the course from game details
      holes: gdetail?.holes?.toString() || "18",  // Auto-select hole count from game details (default to 18)
      media: "",
      isScore: false, // Default to not a score post
      score: "",  // Empty score initially
    });

    // Set the selected value for the dropdown
    setSelectedValue(gdetail?.holes?.toString() || "18");

    // Show the modal
    newPostModal(true);
  };


  const [scoreData, setScoreData] = useState({
    userId: null,
    gameId: gameId,
    scoreValue: "",
    putts: 2, // Set default putts to 2
    penalties: "",
    teeAccuracy: "",
    scoreRound: 0,  // Initialize with 0 instead of undefined
    par: 0,  // Initialize with 0 instead of undefined
    totalDuration: "",
    putDistance: 0, // Set a default midpoint distance
    greenSideBunker: 0,
    fairwayBunker: 0,
    outOfBounds: 0,
    dropShot: 0,
    penaltyArea: 0,
    isFinished: false
  });

  // Function to handle changes in putts distance
  const handlePuttsDistanceChange = (event) => {
    const newDistance = parseInt(event.target.value) || 0; // Convert value to integer with fallback
    setScoreData({ ...scoreData, putDistance: newDistance }); // Update putDistance state
  };

  const handleScoreIncrement = (field) => {
    // Check if the field is greenSideBunker or fairwayBunker and if it's less than 2
    if ((field === 'greenSideBunker' || field === 'fairwayBunker' || field === 'dropShot' || field === 'penaltyArea' || field === 'outOfBounds') && scoreData[field] < 2) {
      setScoreData((prevScoreData) => ({
        ...prevScoreData,
        [field]: prevScoreData[field] + 1,
      }));
    }
  };


  // Update your context provider setup in the ScoreKeeping component
  const [holeContextValue, setHoleContextValue] = useState({
    currentHole,
    setCurrentHole,
    maxHoles: holeMax || 18,
    serverRoundDuration: 0
  });

  // Update context value when dependencies change
  useEffect(() => {
    setHoleContextValue({
      currentHole,
      setCurrentHole,
      maxHoles: holeMax || 18,
      serverRoundDuration
    });
  }, [currentHole, holeMax, serverRoundDuration]);


  // Update server time handling in the game details API response
  useEffect(() => {
    request({
      url: `app/game/game-detail/${id}`,
      method: "GET",
      onSuccess: (data) => {
        // console.log("game details", data);
        // Fix: Normalize the totalDuration value
        const duration = data.data.totalDuration;

        // Ensure totalDuration is a valid number in seconds
        const normalizedDuration = typeof duration === 'number' ? duration :
          parseInt(duration, 10) || 0;

        // Cap very large values to prevent unrealistic displays
        const cappedDuration = normalizedDuration > 86400 * 365 ? 0 : normalizedDuration;

        // console.log('Normalized game Details time duration For Round:', cappedDuration);

        // Set server round duration
        setServerRoundDuration(cappedDuration);
        const gameDetailsId = () => {
          return [...data.data.gameDetailsId].sort((a, b) => {
            if (a.user._id === data.data.user._id) return -1;
            if (b.user._id === data.data.user._id) return 1;
            return 0;
          });
        };

        setGameCreator(data.data.user._id)
        // console.log("NEW GAME DATA", gameDetailsId());

        const updatedGameDetails = { ...data.data, gameDetailsId: gameDetailsId() };
        setGameDetail(updatedGameDetails);

        setholeMax(data.data.holes);
        scoreDetail(data.data);

        // Auto-advance to the correct hole based on scores
        findCurrentActiveHole(data.data);

        if (data.data.isFinished) {
          // If game is finished, don't change active hole
          clearStorageAfterEndGame();
          openGameEndPopup()
        }
      },
      onError: (error) => {
        // console.log(error);
      },
    });
    checkAllPlayersScored()
  }, []);

  const clearStorageAfterEndGame = () => {
    try {
      // Get the stored games data
      const storageKey = "activeGameHoles";
      const storedGames = JSON.parse(localStorage.getItem(storageKey)) || {};

      // Check if the current game exists in storage
      if (storedGames[`game_${gameId}`]) {
        // Remove just this game's data
        delete storedGames[`game_${gameId}`];

        // Save the updated storage without this game
        localStorage.setItem(storageKey, JSON.stringify(storedGames));
        // console.log(`Game ${gameId} data cleared from localStorage`);
      } else {
        // console.log(`No data found for game ${gameId}`);
      }
    } catch (error) {
      console.error("Error clearing game data:", error);
    }
  };

  const findCurrentActiveHole = (gameData) => {
    const maxHoles = gameData.holes;

    // Start checking from hole 1 to max holes
    let checkHole = 1;
    const checkNextHole = () => {
      request({
        url: `app/score/score-detail/${checkHole}/${gameId}`,
        method: "GET",
        onSuccess: (data) => {
          // console.log("score Deatils here", data)
          const allScores = data.data.data;
          const totalPlayers = gameData?.gameDetailsId?.length || 0;

          // Check if all players have scores for this hole
          const allPlayersScored = allScores.length === totalPlayers &&
            allScores.every(score => score.scoreValue !== null && score.scoreValue !== undefined);

          if (!allPlayersScored || checkHole === maxHoles) {
            // If not all players scored or we're at max holes, this is the current hole
            setCurrentHole(checkHole);
            setShowLiveCamera(false);
            setTimeout(() => {
              setShowLiveCamera(true)
            }, 100);
            updateActiveHole(checkHole)
            // setActiveHole(checkHole)
          } else if (checkHole < maxHoles) {
            // Check the next hole
            checkHole++;
            checkNextHole();
          }
        },
        onError: (error) => {
          // console.log(error);
          // In case of error, default to hole 1
          setShowLiveCamera(false);
          setTimeout(() => {
            setShowLiveCamera(true)
          }, 100);
          setCurrentHole(1);
        }
      });
    };

    // Start the recursive check
    checkNextHole();
  };

  const holes_max = holeMax;

  const handlechange = (event) => {
    const { name, value, type, checked } = event.target;
    const newValue = type === 'checkbox' ? checked : value;

    setFormData({ ...formData, [name]: newValue });
    if (name in scoreData) {
      setScoreData({ ...scoreData, [name]: value });
    }
  };


  const openAddScoreModal = (userId) => {
    // console.log("Opening score modal for userId:", userId);
    // console.log("INITUSERPar",gdetail.gameDetailsId.find(item => item.user._id === userId)?.par)
    const userIPar = gdetail.gameDetailsId.find(item => item.user._id === userId);
    setUserInitPar(Number(userIPar.userpar))
    // }
    // Ensure we have the latest hole details before opening the modal
    request({
      url: `/common/scoreData/${gdetail?.course}/${gdetail?.courseTee?._id}/${currentHole}`,
      method: 'GET',
      onSuccess: (data) => {

        setSdetail(data.data);
        // console.log("seting par try here", data.data.par, "data", data, "gdetail", gdetail)
        // Set default score to par value if available
        const parValue = data.data.par;
        setSelectedNumber(Number(parValue) || 4);

        // Initialize scoreData with all required fields properly set
        const initialScoreData = {
          userId: userId,
          gameId: gameId,
          scoreValue: selectedNumber.toString(), // Use currently selected number
          putts: "2",  // Default to 0
          penalties: "0",  // Default to 0
          teeAccuracy: "",
          scoreRound: currentHole,  // Set to the current hole number
          par: data.data.par || 0,  // Set par from the hole data
          totalDuration: serverRoundDuration ? serverRoundDuration.toString() : "0",
          putDistance: "15",  // Default to 0
          greenSideBunker: 0,
          fairwayBunker: 0,
          outOfBounds: 0,
          dropShot: 0,
          penaltyArea: 0,
          isFinished: currentHole === parseInt(holes_max)  // Use strict equality check
        };

        // console.log("Initializing score data:", initialScoreData);
        setScoreData(initialScoreData);
        setAddScoreShow(true);
      },
      onError: (error) => {
        // console.log("Error fetching hole details:", error);
        // Open modal anyway with basic data
        const fallbackScoreData = {
          userId: userId,
          gameId: gameId,
          scoreValue: selectedNumber.toString(), // Use currently selected number
          putts: "0",  // Default to 0
          penalties: "0",  // Default to 0
          scoreRound: currentHole,
          par: Sdetail?.par || 0,
          totalDuration: serverRoundDuration ? serverRoundDuration.toString() : "0",
          putDistance: "0",
          greenSideBunker: 0,
          fairwayBunker: 0,
          outOfBounds: 0,
          dropShot: 0,
          penaltyArea: 0,
          isFinished: currentHole === parseInt(holes_max)  // Use strict equality check
        };
        // console.log("Fallback score data:", fallbackScoreData);
        setScoreData(fallbackScoreData);
        setAddScoreShow(true);
      }
    });
  };

  useEffect(() => {
    request({
      url: "app/friend/user-friend-list",
      method: "GET",
      onSuccess: (data) => {
        setFriendList(data?.data?.data)
      },
      onError: (error) => {
        // console.log("Error in fetching friend List", error)
      }
    });

    setUserProfile();
    scoreInAddScore(gameId, currentHole);
    gameDetail()
  }, [location, gameId, currentHole]);

  const setUserProfile = () => {
    request({
      url: "app/user/get-profile",
      method: "GET",
      onSuccess: (data) => {
        setProfile(data.data); // Assuming the API response contains the user profile data
      },
      onError: (error) => {
        // console.log("Error fetching profile:", error);
      }
    });
  };

  const scoreDetail = async (data) => {
    const courseTee = data ? data?.courseTee?._id : gdetail?.courseTee?._id;
    const course = data ? data?.course : gdetail?.course;

    if (!course || !courseTee) {
      // console.log("Missing course or courseTee data");
      return;
    }

    request({
      url: `/common/scoreData/${course}/${courseTee}/${currentHole}`,
      method: 'GET',
      onSuccess: (data) => {
        // console.log("ScoreDeatils Data", data)
        setSdetail(data.data);
        // Update scoreData with the new hole info
        setScoreData(prev => ({
          ...prev,
          scoreRound: data.data.hole,
          par: data.data.par
        }));
        setSelectedNumber(Number(data.data.par) || 4);
      },
      onError: (error) => {
        // console.log("Error fetching score details:", error);
      },
    });
  };

  const updateActiveHole = (nextHole) => {
    const storageKey = "activeGameHoles";
    try {
      const storedGames = JSON.parse(localStorage.getItem(storageKey)) || {};

      // Update only the ActiveHole property while preserving all other properties
      storedGames[`game_${gameId}`] = {
        ...storedGames[`game_${gameId}`], // Keep all existing properties
        ActiveHole: nextHole              // Update only this property
      };

      localStorage.setItem(storageKey, JSON.stringify(storedGames));
    } catch (error) {
      console.error("Error updating active hole data:", error);
    }
  };


  // Modify how you handle adding scores
  const handleAddScore = async () => {
    // Create a new object to avoid mutating state directly
    const scoreDataToSubmit = { ...scoreData,    
      scoreValue: selectedNumber, // Use the selectedNumber state
 };

    // Convert scoreValue putts from string to number
    scoreDataToSubmit.scoreValue = parseInt(scoreDataToSubmit.scoreValue, 10);
    scoreDataToSubmit.putts = parseInt(scoreDataToSubmit.putts, 10);

    // Ensure values are properly set before sending
    if (!scoreDataToSubmit.scoreRound) {
      scoreDataToSubmit.scoreRound = currentHole;
    }

    if (!scoreDataToSubmit.par && Sdetail?.par) {
      scoreDataToSubmit.par = Sdetail.par;
    }

    // Ensure scoreValue is set to the selected number
    if (!scoreDataToSubmit.scoreValue) {
      scoreDataToSubmit.scoreValue = selectedNumber;
    }

    // any way par number
    // if (scoreDataToSubmit.par >)
    var sn = scoreDataToSubmit.scoreValue - Sdetail.par;
    scoreDataToSubmit.userpar = Number(sn) + Number(userInitPar)

    const storageKey = "activeGameHoles";

    const storedGames = JSON.parse(localStorage.getItem(storageKey)) || {};

    if (storedGames[`game_${gameId}`]) {
      const gameData = storedGames[`game_${gameId}`];

      scoreDataToSubmit.totalDuration = gameData[`hole${currentHole}`] || 0;

    }
    // Set isFinished based on whether this is the last hole
    const isLastHole = parseInt(currentHole) === parseInt(holes_max);

    // check all pleayers scored 
    // Wait for all players scored check
    const allpscored = await checkAllPlayersScoredReturned();


    scoreDataToSubmit.isFinished = isLastHole && allpscored;

    // console.log("GAAMEE FINISHEING IS YES OR NO", scoreDataToSubmit.isFinished)
    // console.log("Sending score data", scoreDataToSubmit, "TEST", scoreDataToSubmit.par);

    if (currentHole < holes_max) {
      const nextHole = parseInt(currentHole) + 1;
      updateActiveHole(nextHole.toString())
    }

    request({
      url: "/app/score/add-score",
      method: "POST",
      data: scoreDataToSubmit,
      onSuccess: (data) => {
        // console.log("Score added successfully:", data);

        scoreInAddScore(gameId, currentHole);
        gameDetail(gameId);
        closeAddScoreModal();
        // Check if all players have submitted scores for the current hole
        checkAllPlayersScored();
        // openGameFinishedPopup()

      },
      onError: (error) => {
        // console.log("Error adding score:", error);
      },
    });
  };


  const checkAllPlayersScoredReturned = () => {
    return new Promise((resolve, reject) => {
      request({
        url: `app/score/score-detail/${currentHole}/${gameId}`,
        method: "GET",
        onSuccess: (data) => {
          console.log("score here", data)
          const allScores = data.data.data;
          const totalPlayers = gdetail?.gameDetailsId?.length || 0;

          const allPlayersScored = allScores.length === totalPlayers || allScores.length === totalPlayers - 1 &&
            allScores.every(score => score.scoreValue !== null && score.scoreValue !== undefined && score.scoreValue !== 0);

          resolve(allPlayersScored);
        },
        onError: (error) => {
          console.log(error);
          reject(false);
        }
      });
    });
  };

  // Replace the checkAllPlayersScored function with this improved version
  const checkAllPlayersScored = () => {
    request({
      url: `app/score/score-detail/${currentHole}/${gameId}`,
      method: "GET",
      onSuccess: (data) => {
        const allScores = data.data.data;
        const totalPlayers = gdetail?.gameDetailsId?.length || 0;

        console.log("All Scores %%%%%%%%%%%%%%555", allScores, "totalPlayers", totalPlayers, "tot",)
        // Check if all players have scores for the current hole
        const allPlayersScored = allScores.length === totalPlayers &&
          allScores.every(score => score.scoreValue !== null && score.scoreValue !== undefined && score.scoreValue !== 0);

        // If all players have scored and not the last hole, automatically advance to next hole
        if (allPlayersScored && currentHole < holes_max) {
          updateActiveHole(currentHole + 1)
          // Use a timeout to ensure the UI updates first
          setTimeout(() => {
            setShowLiveCamera(false);
            setTimeout(() => {
              setShowLiveCamera(true)
            }, 100);
            setCurrentHole(prevHole => prevHole + 1);
          }, 1000);
        } else if (allPlayersScored && currentHole == holes_max) {
          // If last hole and all players scored, show game finished popup
          openGameEndPopup()
        }
      },
      onError: (error) => {
        // console.log(error);
      }
    });
  };

  const gameDetail = () => {
    request({
      url: `app/game/game-detail/${id}`,
      method: "GET",
      onSuccess: (data) => {
        // console.log("game deatils !!!!!!!!", data)

        // setGameDetail(data.data);
        const gameDetailsId = () => {
          return [...data.data.gameDetailsId].sort((a, b) => {
            if (a.user._id === data.data.user._id) return -1;
            if (b.user._id === data.data.user._id) return 1;
            return 0;
          });
        };

        // console.log("NEW GAME DATA", gameDetailsId());

        const updatedGameDetails = { ...data.data, gameDetailsId: gameDetailsId() };
        setGameDetail(updatedGameDetails);

        setServerRoundDuration(data.data.totalDuration || 0);
        scoreDetail(data.data);
        if (data.data.isFinished) {
          openGameEndPopup()
        }
      },
      onError: (error) => {
        // console.log(error);
      },
    });
  };


  // Modified arrow click handlers to better manage hole timer
  const handleLeftArrowClick = () => {
    if (currentHole > 1) {
      setCurrentHole(prevHole => {
        const newHole = prevHole - 1;
        return newHole;
      });
    }
    setShowLiveCamera(false);
    setTimeout(() => {
      setShowLiveCamera(true)
    }, 100);
  };

  const handleRightArrowClick = () => {
    const updatedHole = currentHole + 1;
    if (updatedHole <= holes_max) {
      setCurrentHole(updatedHole);
    } else {
      // console.log("Reached the maximum number of holes");
    }
    setShowLiveCamera(false);
    setTimeout(() => {
      setShowLiveCamera(true)
    }, 100);
  };

  const scoreInAddScore = (gameId, currentHole) => {
    request({
      url: `app/score/score-detail/${currentHole}/${gameId}`,
      method: "GET",
      onSuccess: (data) => {
        // Compare data to avoid unnecessary rerenders
        if (JSON.stringify(addScore) !== JSON.stringify(data.data.data)) {
          setAddScore(data.data.data);
        }
      },
      onError: (error) => {
        // console.log(error);
      }
    });
  };

  const scoreCardData = async () => {
    request({
      url: `/app/score/get-score-game/${gameId}`,
      method: "GET",
      onSuccess: (data) => {
        // console.log("get scoer game", data);
        navigate(`/gameDetail/${id}`, { state: { response: data.data } })
        setScoreCard(data.data)
      },
      onError: (error) => {
        // console.log(error);
        // ShowToast(error, Severty.ERROR);
      },
    });
  }
  const handleCheckboxChange = (friendId) => {
    // console.log("friendId", friendId)
    // Check if the friendId is already in the selectedFriends array
    if (selectedFriends.includes(friendId)) {
      // If it is, remove it from the selectedFriends array
      setSelectedFriends(selectedFriends.filter(id => id !== friendId));
    } else {
      // If it's not, add it to the selectedFriends array
      setSelectedFriends([...selectedFriends, friendId]);
    }
  };

  const addPlayerData = () => {
    // Make the API call only if at least one friend is selected
    if (selectedFriends.length > 0) {
      const requestData = {
        id: profile?._id,
        players: selectedFriends ? selectedFriends : [] // Pass the array of selected friend IDs to the API
      };
      // console.log("requestedData", requestData)
      request({
        url: `app/game/joinPlayer`,
        method: "PUT",
        data: requestData,
        onSuccess: (data) => {
          // console.log("player joined successfully", data);
          addPlayerModalClose()

        },
        onError: (error) => {
          // console.log("Error in joining player", error)
        }
      })
    } else {
      // console.log("Please select at least one friend and provide the group ID.");
    }
  };


  const handleSubmit = async (event) => {
    event.preventDefault();

    // Create a new form data object to send
    const postData = {
      ...formData,
      holes: selectedValue,
      course: gdetail.courseData?.name,
      isPrivate: gdetail.posts_privacy,
      gameId: gameId
    };

    // Remove the score field if isScore is false
    if (!postData.isScore) {
      delete postData.score;
    }

    // console.log('Sending post data:', postData);

    request({
      url: "/app/post/add-post",
      method: "POST",
      data: postData,
      onSuccess: (data) => {
        ShowToast("Post Added Successfully", Severty.SUCCESS);
        newPostModalClose();
        setFormData({
          title: "",
          description: "",
          course: "",
          holes: "",
          media: "",
          isScore: false,
          score: "",
        });
      },
      onError: (error) => {
        // console.log(error);
        // ShowToast(error, Severty.ERROR);
      },
    });
  };



  const fileUploads = (event) => {
    setLoading(true)
    const file = event.target.files[0];
    const formdata = new FormData()
    formdata.append('image', file)
    request({
      url: "/common/image-upload",
      method: "POST",
      data: formdata,
      onSuccess: (data) => {
        // console.log("check data ", data.data.upload);
        setFormData({ ...formData, media: data.data.upload })
        setLoading(false)
      },
      onError: (error) => {
        // console.log(error);
        setLoading(false)
      },
    });
  }

  const fileUploadsEnd = (event) => {
    setLoading(true)
    const file = event.target.files[0];
    const formdata = new FormData()
    formdata.append('image', file)
    request({
      url: "/common/image-upload",
      method: "POST",
      data: formdata,
      onSuccess: (data) => {
        // console.log("check data ", data.data.upload);
        setFormEndData({ ...formData, media: data.data.upload })
        setLoading(false)
      },
      onError: (error) => {
        // console.log(error);
        setLoading(false)
      },
    });
  }


  return (
    <>
      <HoleContext.Provider value={holeContextValue}>
        <Main>
          <section className="home-wrap px-2 pb-2 container-fluid">
            <div className="row g-0">
              <div className="col-12">
                <div className="pagreHeader">
                  <div className="pageHeadign d-flex align-items-center gap-3 mb-3">
                    <button onClick={handleOpenModal} className="btn backBtn bg-transparent border-0 shadow-none p-0 d-flex">
                      <img className="h-100" src={backArrow} />
                    </button>
                    <Modal show={showModal} onHide={handleCloseModal}>
                      <Modal.Header closeButton>
                        <Modal.Title>Confirmation</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>Are you sure you want to quit?</Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseModal}>
                          No
                        </Button>
                        <Button
                          variant="primary"
                          onClick={() => {
                            navigate("/play");
                            handleCloseModal();
                          }}
                        >
                          Yes
                        </Button>
                      </Modal.Footer>
                    </Modal>
                    <div className="txt">Score Keeping</div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="row g-2">
                  <div className="col-12">
                    <div className="eventcard mb-2 d-flex flex-column" style={{ borderRadius: 0, margin: 0, padding: 0 }}>
                      <div className="cardHead py-2 border-bottom bg-white" style={{ borderRadius: 0 }}>
                        <div className="holeHeading d-flex align-items-center justify-content-between px-2 py-1">
                          <button type="button" className="btn p-0 bg-transparent border-0" onClick={handleOpenModal}>
                            <img className="h-100" src={exitIcon} alt="Exit" />
                          </button>
                          <div className="d-flex align-items-center gap-2">
                            <button type="button" className="btn p-0 bg-transparent border-0" onClick={() => handleLeftArrowClick()}>
                              <img className="h-100" src={leftBtnArrow} alt="Previous" />
                            </button>
                            <div className="text fs-6 fw-medium text-dark">Hole {currentHole}</div>
                            <button type="button" className="btn p-0 bg-transparent border-0" onClick={() => handleRightArrowClick()}>
                              <img className="h-100" src={rightBtnArrow} alt="Next" />
                            </button>
                          </div>
                          <div className="invisible">
                            <img className="h-100" src={exitIcon} alt="Placeholder" />
                          </div>
                        </div>
                        <div className="text-muted fs-14 text-center pb-1">Par {Sdetail?.par} Yards {Sdetail?.value} l {Sdetail?.handicap}</div>
                      </div>

                      {/* Timer section - all elements on one line */}
                      <div className="cardBody py-2 px-2">
                        <div className="w-100 d-flex align-items-center">
                          <div className="d-flex align-items-center gap-2">
                            <img src={clockIconFill} alt="Clock" />
                            <ImprovedTimer serverRoundDuration={serverRoundDuration} />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <button type="button" onClick={addPlayerModalOpen} className="btn btnStyle1 px-0 py-2 border-0 shadow-none bg-transparent d-flex align-items-center gap-2 w-100"><img className="h-100" src={addPlayerIcon} /> Add Players</button> */}

                    {/* Players section - reduced padding/margins */}
<div className="col-12">
  <div className="eventcard bg-white" style={{ padding: '0.5rem' }}>
    {gdetail?.gameDetailsId?.map((list, index) => {
      // Find the score for this specific user by userId - handle both string and object formats
      const userScore = addScore.find(score => {
        if (typeof score.userId === 'string') {
          return score.userId === list?.user?._id;
        } else if (score.userId && typeof score.userId === 'object') {
          return score.userId._id === list?.user?._id;
        }
        return false;
      });
      
      // Check if this user has already scored for the current hole
      const hasScored = userScore && userScore.scoreValue !== null && userScore.scoreValue !== undefined;
      
      return (
        <div
          className="playerItem"
          key={list?.user?._id || index}
          style={{
            position: 'relative',
            height: '60px',
            paddingTop: '5px',
            paddingBottom: '5px'
          }}
        >
          {/* Left section with image and text - positioned absolutely */}
          <div
            style={{
              position: 'absolute',
              left: '0',
              top: '50%',
              transform: 'translateY(-50%)',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              maxWidth: 'calc(100% - 100px)',
              overflow: 'hidden'
            }}
          >
            <div
              className="imgOuter rounded-circle overflow-hidden"
              style={{
                width: '50px',
                height: '50px',
                flexShrink: 0
              }}
            >
              <img
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                src={
                  list?.user?.profilePic
                    ? `https://pwabucket1.s3.amazonaws.com/${list?.user?.profilePic}`
                    : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                      list?.user?.name
                    )}&size=256`
                }
                alt={list.name}
              />
            </div>
            <div style={{ overflow: 'hidden', minWidth: 0 }}>
              <div className="fs-14 fw-medium text-dark" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {list?.user?.name}
              </div>
              <div className="text-muted fs-12" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {list?.totalScore}
                {list?.userpar === 0 ? ` (E)` : ` (${Math.abs(list?.userpar)}${list?.userpar > 0 ? '+' : '-'})`}
              </div>
            </div>
          </div>

          {/* Right section with button - positioned absolutely */}
          <div
            style={{
              position: 'absolute',
              right: '0',
              top: '50%',
              transform: 'translateY(-50%)',
              width: '90px'
            }}
          >
            <Button
              disabled={hasScored}
              className="btn btnOutlineTheme2 p-1 fs-12"
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              onClick={() => openAddScoreModal(list?.user?._id)}
            >
              <img src={plusIconTheme2} style={{ width: '14px', marginRight: '2px' }} />
              {hasScored ? (
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {userScore.scoreValue}
                </span>
              ) : (
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  Add Score
                </span>
              )}
            </Button>
          </div>
        </div>
      );
    })}
  </div>
</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              {/* For mobile view - at the bottom of content */}
              <div className="d-md-none w-100 mt-4 mb-5 pb-3">
                <div className="d-flex justify-content-between">
                  <Button className="btn btnOutlineTheme2" onClick={() => scoreCardData()}>
                    Scoreboard
                  </Button>
                  <Button className="btn btnOutlineTheme2" onClick={newPostModalOpen}>
                    Add Post
                  </Button>
                </div>
              </div>

              <div className="d-md-none w-100 mt-4 mb-5 pb-3">
                {/* <div className="d-flex justify-content-between">
                  {gdetail?.course ? &&  showLiveCamera  (
                    <LiveCamera gdetail={gdetail} />
                  ) : ''
                  }
                </div> */}
                <div className="d-flex justify-content-between">
                  {(gdetail?.course && showLiveCamera) ? (
                    <>
                    {/* <LiveCamera gdetail={gdetail} /> */}
                    {/* <CameraSocketTester /> */}
                      <LiveCam gdetail={gdetail} />
                    </>
                  ) : null}
                </div>
              </div>

              {/* For desktop view - original position */}
              <div className="col-12 mt-3 d-none d-md-block">
                <Button className="btn btnOutlineTheme2 me-2" onClick={() => scoreCardData()}>
                  Scoreboard
                </Button>
                <Button className="btn btnOutlineTheme2" onClick={newPostModalOpen}>
                  Add Post
                </Button>
              </div>
            </div>
          </section>
        </Main>
      </HoleContext.Provider>

      {/* Add Player Modal  */}
      <Modal show={addPlayerShow} className="headerModals" onHide={addPlayerModalClose} centered>
        <Modal.Header className="p-sm-4 p-3 position-relative justify-content-center" closeButton>
          <Modal.Title>
            <img src={logoVerticaleTheme} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-sm-4 p-3">
          <Form className="row gap-12">
            <Form.Group className="col-12 position-relative">
              <Form.Label htmlFor="contactSearch" style={{ cursor: "pointer" }} className="position-absolute top-0 bottom-0 my-auto end-0 me-3 d-flex align-items-center justify-content-center">
                <img src={searchIcon} />
              </Form.Label>
              <Form.Control className="pe-5"
                type="search"
                id="contactSearch"
                placeholder="Search by username, email or Handicap ID"
                aria-describedby="passwordHelpBlock"
              />
            </Form.Group>
            <Form.Group className="col-md-12 selectPlayerOuter">
              {friendList.map((list) => (
                <Form.Check
                  key={list.id} // Add a unique key prop for each Form.Check component
                  className="selectPlayerCheck m-0 p-0 d-flex align-items-center justify-content-between flex-row-reverse"
                  name="group1"
                  type="checkbox"
                  id={`player_${list.id}`} // Use a unique ID for each Form.Check component
                  onChange={() => handleCheckboxChange(list?._id)} // Pass friend ID to handleCheckboxChange
                  checked={selectedFriends.includes(list?._id)} // Check if the friend ID is in selectedFriends array
                  label={
                    <div className="playerPro d-flex align-items-center gap-2">
                      <div className="playerImg overflow-hidden rounded-circle">
                        <img className="w-100 h-100" src={
                          list?.profilePic
                            ? `https://pwabucket1.s3.amazonaws.com/${list?.profilePic}`
                            : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                              list?.name
                            )}&size=256`
                        } alt="Avatar" />
                      </div>
                      <div className="detail">
                        <div className="name">{list.name}</div>
                        <div className="dec mt-1">{list && list.city}, {list && list.state}</div>
                      </div>
                    </div>
                  }
                />
              ))}
            </Form.Group>

            <Form.Group className="col-12 mt-4 text-end">
              <button type="button" className="btn btnStyle1 btnTheme1 shadow-none px-5 w-100" onClick={addPlayerData}>Add Players</button>
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal
        show={newPostShow}
        size="lg"
        className="headerModals"
        onHide={newPostModalClose}
        centered
      >
        <Modal.Header
          className="p-4 position-relative justify-content-center"
          closeButton
        >
          <Modal.Title>
            <img src={logoVerticaleTheme} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Form className="row g-2" onSubmit={handleSubmit}>
            <Form.Label className="col-12 mb-0">New Post</Form.Label>
            <div className="col-12 mb-0">
              <div className="row">
                <div className="col-12 col-md-6">
                  <Form.Group
                    controlId="formFile"
                    className="uploadFileOuter w-100 h-100"
                  >
                    <Form.Label className="w-100 h-100 d-flex align-items-center justify-content-center">
                      <div className="uploadFile text-center profile-upload">
                        <Spin spinning={loading} size="large">
                          <div className="imgOuter">
                            {formData?.media && formData.media.endsWith('.mp4') ? (
                              <video src={`https://pwabucket1.s3.amazonaws.com/${formData.media}`} autoPlay="true" type="video/mp4" />
                            ) : (
                              <img src={formData?.media ? `https://pwabucket1.s3.amazonaws.com/${formData?.media}` : fileUploadIcon} />
                            )}
                          </div>
                          <div className="txt mt-3">Upload Img or video</div>
                        </Spin>
                      </div>
                    </Form.Label>
                    <Form.Control className="d-none" type="file" name="media" onChange={fileUploads} />
                  </Form.Group>
                </div>
                <div className="col-12 mt-md-0 mt-3 col-md-6">
                  <div className="row gap-12">
                    <Form.Group className="col-12">
                      <Form.Control
                        className="sahdow-none"
                        type="text"
                        name="title"
                        onReset={Form}
                        required="title"
                        placeholder="Title"
                        onChange={handlechange}
                        value={formData.title || ""}
                      />
                    </Form.Group>
                    <Form.Group className="col-12 position-relative">
                      <Form.Control
                        as="textarea"
                        className="sahdow-none"
                        type="text"
                        onReset={Form}
                        name="description"
                        placeholder="Description"
                        onChange={handlechange}
                        value={formData.description || ""}
                        rows={3}
                      />
                    </Form.Group>
                    <Form.Group controlId="formCourse">
                      <Form.Label>Course</Form.Label>
                      <Form.Control
                        as="select"
                        name="course"
                        required="course"
                        onReset={Form}
                        value={formData.course || ""}
                        onChange={handlechange}
                      >
                        <option value="">Select Course</option>
                        {courseList.map((course) => (
                          <option key={course.id} value={course.id}>
                            {course.name}
                          </option>
                        ))}
                        {/* Show the current game course if not in the list */}
                        {gdetail?.course && !courseList.find(c => c.id === gdetail.course) && (
                          <option value={gdetail.course}>
                            {gdetail.courseData?.name || "Current Course"}
                          </option>
                        )}
                      </Form.Control>
                    </Form.Group>

                    <Form.Group className="col-12">
                      <Form.Label>Holes</Form.Label>
                      <Form.Select
                        aria-label="Select holes"
                        name="holes"
                        value={selectedValue}
                        onChange={(e) => setSelectedValue(e.target.value)}
                      >
                        <option value="">Select Hole</option>
                        <option value="9">Hole 9</option>
                        <option value="18">Hole 18</option>
                      </Form.Select>
                    </Form.Group>

                    {/* Add Score Switch */}
                    <Form.Group className="col-12 mt-2">
                      <div className="d-flex align-items-center justify-content-between">
                        <Form.Label className="mb-0">Is this a score post?</Form.Label>
                        <Form.Check
                          type="switch"
                          id="score-switch"
                          name="isScore"
                          checked={formData.isScore}
                          onChange={(e) => setFormData({ ...formData, isScore: e.target.checked })}
                        />
                      </div>
                    </Form.Group>

                    {/* Conditionally render score input if isScore is true */}
                    {formData.isScore && (
                      <Form.Group className="col-12 mt-2">
                        <Form.Label>Score</Form.Label>
                        <Form.Control
                          type="number"
                          name="score"
                          placeholder="Enter your score"
                          value={formData.score}
                          onChange={handlechange}
                          min="1"
                          required
                        />
                      </Form.Group>
                    )}

                    {/* Display the current hole score summary if available */}
                    {currentHole && (
                      <Form.Group className="col-12 mt-2">
                        <div className="current-hole-info p-2 border rounded">
                          <div className="fw-medium">Current Hole: {currentHole}</div>
                          {addScore && addScore.length > 0 && (
                            <div className="small text-muted">
                              Scores: {addScore.map(score => score.scoreValue).filter(Boolean).join(', ')}
                            </div>
                          )}
                        </div>
                      </Form.Group>
                    )}
                    <Form.Group className="col-12 mt-4 text-end">
                      <button
                        type="submit"
                        className="btn btnStyle1 btnTheme1 shadow-none px-5 text-center w-100"
                      >
                        Post
                      </button>
                    </Form.Group>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>


      <Modal show={addScoreShow} onHide={closeAddScoreModal} className="headerModals" centered>
        <Modal.Body>
          <div className="headding-modal">
            <h6>Score Tracker</h6>
          </div>
          <div className="modal-card-01">
            <div className="score-headding">
              <h6>Score</h6>
            </div>
            <div
              className="number-carousel"
              ref={carouselRef}
              style={{
                width: `${carouselWidth}px`,
                margin: "0 auto",
                overflow: "hidden",
              }}
            >
              <DraggableNumberPicker
                initialValue={selectedNumber}
                onNumberChange={(value) => {
                  setSelectedNumber(value);
                  setScoreData(prev => ({ ...prev, scoreValue: value.toString() }));
                }}
              />
            </div>
          </div>

          <div className="modal-card-01">
            <div className="score-headding">
              <h6>Putts</h6>
            </div>
            <div className="putts-type">
              <ul>
                {[0, 1, 2, 3, 4, 5].map(value => (
                  <li key={value} className={scoreData.putts === value.toString() ? 'active' : ''} onClick={() => setScoreData(prev => ({ ...prev, putts: value.toString() }))}>
                    {value}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="modal-card-01">
            <div className="score-headding d-flex justify-content-between">
              <h6>1st Putts Distance</h6>
              <h6>{scoreData.putDistance} FT</h6> {/* Display current putDistance value */}
            </div>
            <div className="putts-type-range">
              <input
                type="range"
                className="form-range"
                id="customRange1"
                min="0"   // Set minimum to 0
                max="30"  // Set maximum to 30
                value={scoreData.putDistance} // Bind value of input to putDistance state
                onChange={handlePuttsDistanceChange} // Call handler function on change
              />
            </div>
          </div>

          <div className="single-post-dtl mt-5">
            {/* Greenside Bunker */}
            <div className="score-post" onClick={() => handleScoreIncrement('greenSideBunker')}>
              <div className="post-info-ic">{scoreData.greenSideBunker}</div>
              <span>Greenside Bunker</span>
            </div>

            {/* Fairway Bunker */}
            <div className="score-post" onClick={() => handleScoreIncrement('fairwayBunker')}>
              <div className="post-info-ic">{scoreData.fairwayBunker}</div>
              <span>Fairway Bunker</span>
            </div>

            {/* Out of Bounds */}
            <div className="score-post" onClick={() => handleScoreIncrement('outOfBounds')}>
              <div className="post-info-ic">{scoreData.outOfBounds}</div>
              <span>Out of Bounds</span>
            </div>

            {/* Drop Shot */}
            <div className="score-post" onClick={() => handleScoreIncrement('dropShot')}>
              <div className="post-info-ic">{scoreData.dropShot}</div>
              <span>Drop shot</span>
            </div>

            {/* Penalty Area */}
            <div className="score-post" onClick={() => handleScoreIncrement('penaltyArea')}>
              <div className="post-info-ic">{scoreData.penaltyArea}</div>
              <span>Penalty Area</span>
            </div>
          </div>

          <div className="btnGroup d-flex flex-column flex-sm-row align-items-center gap-3 mt-4">
            <Button type="button" onClick={closeAddScoreModal} className="btn btnStyle1 btnOutlineTheme1 btnWidth shadow-none px-3 w-100 d-flex align-items-center gap-1 justify-content-center">Cancel</Button>
            <Button type="button" onClick={handleAddScore} className="btn btnStyle1 btnTheme1 btnWidth shadow-none px-3 w-100">Add</Button>
          </div>
        </Modal.Body>
      </Modal>





      {/* end game popup */}
      <Modal show={isEndGame} onHide={closeEndGame}>
        <Modal.Header closeButton>
          <Modal.Title>Game Finished</Modal.Title>
        </Modal.Header>
        <Modal.Body>


          {gdetail?.gameDetailsId
            ?.filter(player => player.user._id === GameCreator) // Only keep players that match GameCreator
            .map(player => (
              // <li key={player._id}>
              //   Name: {player.user.name}
              // </li>
              <Form className="row g-2" onSubmit={HandleSubmitEnd}>
                {/* Score and Putts centered at the top */}
                <div className="d-flex justify-content-center mb-4">
                  <Form.Label className="text-center mx-4">
                    <div className="score-post">
                      <div className="post-info-ic">{player.totalScore}</div>
                      <span style={{ fontSize: "18px", fontWeight: "600" }}>Score</span>
                    </div>
                  </Form.Label>
                  <Form.Label className="text-center mx-4">
                    <div className={`score-post ${!formEndData.isPutts ? "opacity-50" : ""}`}>
                      <div className="post-info-ic">{player.putts}</div>
                      <span style={{ fontSize: "18px", fontWeight: "600" }}>Putts</span>
                    </div>
                  </Form.Label>
                </div>

                {/* Putts message with enhanced text and left-aligned checkbox with blue outline */}
                <div className="col-12 mb-4">
                  <Form.Group>
                    <div className="d-flex align-items-center">
                      <div
                        className="checkbox-container me-3"
                        style={{
                          padding: "6px",
                          borderRadius: "6px",
                          border: "2px solid #1890ff", // Blue border
                          backgroundColor: "#fff",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        <Form.Check
                          type="checkbox"
                          id="include-putts-checkbox"
                          checked={formEndData.isPutts}
                          onChange={(e) => setFormEndData({ ...formEndData, isPutts: e.target.checked })}
                          className="form-check-lg"
                          style={{
                            transform: "scale(1.8)",
                            margin: "0",
                            cursor: "pointer"
                          }}
                        />
                      </div>
                      <p className="mb-0" style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        lineHeight: "1.4"
                      }}>
                        Your Total Putts Are {player.putts} for this round, do you want to post it with the score?
                      </p>
                    </div>
                  </Form.Group>
                </div>

                {/* Centered Upload image section */}
                <div className="col-12 mb-4 d-flex justify-content-center">
                  <div className="col-10 col-md-8 text-center">
                    <Form.Group
                      controlId="formFile"
                      className="uploadFileOuter w-100"
                    >
                      <Form.Label className="w-100 d-flex align-items-center justify-content-center">
                        <div className="uploadFile text-center profile-upload">
                          <Spin spinning={loading} size="large">
                            <div className="imgOuter">
                              {formEndData?.media && formEndData.media.endsWith('.mp4') ? (
                                <video src={`https://pwabucket1.s3.amazonaws.com/${formEndData.media}`} autoPlay="true" type="video/mp4" />
                              ) : (
                                <img src={formEndData?.media ? `https://pwabucket1.s3.amazonaws.com/${formEndData?.media}` : fileUploadIcon} />
                              )}
                            </div>
                            <div className="txt mt-3" style={{ fontWeight: "600", fontSize: "16px" }}>Upload Img or video</div>
                          </Spin>
                        </div>
                      </Form.Label>
                      <Form.Control className="d-none" type="file" name="media" onChange={fileUploadsEnd} />
                    </Form.Group>
                  </div>
                </div>




                <div className="col-12 text-center">
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="submit-btn"
                    size="large"
                    disabled={loading} // Disable button while loading is true
                  >
                    {loading ? "Uploading..." : "Upload Post"}
                  </Button>
                </div>
              </Form>
            ))}



          {gdetail?.gameDetailsId
            ?.filter(player => player.user._id !== GameCreator) // Exclude the GameCreator
            .length > 0 && (
              <>
                {/* Divider */}
                <div className="col-12 my-4">
                  <hr className="divider" />
                  <h5 className="text-center fw-bold mt-3">Other Players Posts</h5>
                </div>

                {/* Other players list - displayed in a row with flex wrap */}
                <div className="d-flex flex-wrap justify-content-center gap-4 mt-3">
                  {gdetail?.gameDetailsId
                    ?.filter(player => player.user._id !== GameCreator)
                    .map(player => (
                      <div key={player._id} className="text-center mb-3" style={{ width: "120px" }}>
                        {/* Player avatar */}
                        <div className="d-flex justify-content-center">
                          <div
                            className="imgOuter rounded-circle overflow-hidden"
                            style={{
                              width: '70px',
                              height: '70px',
                              margin: '0 auto'
                            }}
                          >
                            <img
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                              src={player?.user?.profilePic
                                ? `https://pwabucket1.s3.amazonaws.com/${player?.user?.profilePic}`
                                : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                  player?.user?.name
                                )}&size=256`}
                              alt={player.user.name}
                            />
                          </div>
                        </div>

                        {/* Player name below avatar */}
                        <div className="mt-2 fw-medium text-dark" style={{
                          fontSize: "14px",
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis'
                        }}>
                          {player?.user?.name}
                        </div>

                        {/* Score circle - matching the style from the top section */}
                        <div className="d-flex justify-content-center mt-2">
                          <div className="score-post" style={{ transform: "scale(0.8)" }}>
                            <div className="post-info-ic">{player?.totalScore}</div>
                            <span style={{ fontSize: "16px", fontWeight: "600" }}>Score</span>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </>
            )
          }


        </Modal.Body>
      </Modal>


      {/* <Button onClick={setIsEndGame(!isEndGame)}>EndGame</Button> */}
    </>
  );
}



export default ScoreKeeping;

// up



